import { call, put, takeEvery } from 'redux-saga/effects';
// import exampleTheme from 'theme/theme.example.json';
import uiActions from '../ui/actions';
import themeActions from './actions';

const legacyStylesheets = [
  '/oao/glu/glu.css',
  '/oao/style.css',
  '/oao/assets/css/default.css',
  '/oao/assets/css/custom.css',
];

function* getTheme({ payload }) {
  try {
    const response = yield call(payload.request);
    const { data } = response;
    yield put(themeActions.getSuccess(data));
    // yield put(themeActions.getSuccess(exampleTheme));
  } catch (e) {
    yield put(themeActions.getFailed({}));

    yield put(themeActions.getLegacy(legacyStylesheets));
  }
}

function* getLegacyTheme({ payload }) {
  const date = Math.round(new Date().getTime() / 1000);

  try {
    payload.forEach((url) => {
      const urlObj = new URL(`${window.location.origin}${url}`);
      const styles = document.createElement('link');
      styles.rel = 'stylesheet';
      styles.type = 'text/css';
      urlObj.searchParams.append('v', date);
      styles.href = urlObj.href;
      document.getElementsByTagName('head')[0].appendChild(styles);
    });
    yield put(themeActions.getLegacySuccess());
  } catch (e) {
    window.console.log(e);
    window.console.error('error pulling legacy stylesheet');
  }
}

function* showUi() {
  try {
    yield (document.querySelector('.glu').style.opacity = 1);
  } catch (e) {
    if (process.env.REACT_APP_ENV !== 'test') {
      window.console.log(e);
    }
  }
}

function* initTheme() {
  yield put(themeActions.getTheme());
}

export default [
  takeEvery(uiActions.INIT, initTheme),
  takeEvery(themeActions.GET, getTheme),
  takeEvery(themeActions.GET_LEGACY, getLegacyTheme),
  takeEvery(themeActions.GET_SUCCESS, showUi),
  takeEvery(themeActions.GET_LEGACY_SUCCESS, showUi),
];
